<div class="order-steps">
  <div
    class="order-steps__step"
    *ngFor="let step of formattedSteps(); let i = index"
    [ngClass]="{
      '--completed': step.status === 'completed',
      '--warning': step.status === 'warning',
      '--exception': step.status === 'exception'
    }"
  >
    <span class="icon material-symbols-outlined">
      {{ step.status === 'exception' ? 'cancel' : step.status === 'warning' ? 'error' : step.icon }}
    </span>

    <p class="label">{{ step.label }}</p>
    <p class="datetime" *ngIf="step.date">{{ step.date }}</p>
  </div>
</div>
